var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: \"ZhenyanGB\";\n  src: url(" + escape(require("./RuiZiZhenYanTiMianFeiShangYong-2.ttf")) + ") format('truetype');\n  font-weight: normal;\n  font-style: normal\n}\n", ""]);

// exports
